import { defineStore } from 'pinia'
import { inject, ref } from 'vue'
import type { Api } from '@/api'
import { Exhibitor } from '@/model'
import { useRoute, useRouter } from 'vue-router'
import { useSiteStore } from './site'

const exhibitorApplicationRoutes = ['exhibition-application-submit', 'exhibition-application-check']

export const useExhibitorStore = defineStore('exhibitorStore', () => {
  const api = inject('exhibitorApi') as Api<unknown>
  const exhibitor = ref<Exhibitor>(Exhibitor.Empty)
  const siteStore = useSiteStore()
  const route = useRoute()
  const router = useRouter()

  async function refreshExhibitor(fairId: number) {
    if (exhibitor.value.fairId === fairId) {
      if (!exhibitorApplicationRoutes.includes(route.name as string)) {
        goToApplication(fairId)
        return
      }
    }

    if (fairId === 0) {
      exhibitor.value = Exhibitor.Empty

      if (siteStore.pageReady) {
        router.push({ name: 'root-fair_list' })
      }
    } else {
      exhibitor.value = await api.exhibitor.byFairDetail(fairId).then((res) => new Exhibitor(res.data))

      if (!exhibitorApplicationRoutes.includes(route.name as string) && siteStore.pageReady) {
        goToApplication(fairId)
      }
    }
  }

  function goToApplication(fairId: number) {
    const routeName = exhibitor.value.isEmpty() ? 'exhibition-application-submit' : 'exhibition-application-check'
    router.push({ name: routeName, params: { FAIR_ID: fairId } })
  }

  return { exhibitor, refreshExhibitor, goToApplication }
})
